<!--
- 专题图谱（手机端）
- author: lzp
- greatTime: 2019-10-29
-->
<template lang="html">
  <div class="map-container">
    <div class="map-item" v-for="item in list" v-if="$route.name != 'MSpecialDetail' || item.map_status == '1'" :key="item.map_id">
      <p class="title" v-if="item.hide_title != '1'"><i class="iconfont">&#xe6e2;</i> {{item.title}}</p>
      <p class="summary" v-if="item.summary" v-html="item.summary"></p>
      <div class="logo-area">
        <div class="length1" :class="{'length2': list_all['map'+item.map_id].length >= 2 && (index == 0 || index == 1)}" v-for="(fa, index) in list_all['map'+item.map_id]" :key="item.module_id">
          <div class="arr-title">
            <img class="left" :src="$store.state.static_img_url + 'mobile/pic/shareMap/title-left.png'"></img>
            <div class="text">{{fa.name}}</div>
            <img class="right" :src="$store.state.static_img_url + 'mobile/pic/shareMap/title-right.png'"></img>
          </div>
          <div class="logos">
            <div class="img-div" v-for="(logo, logo_index) in fa.arr" :key="logo.logo_path" v-if="fa.is_open?true:(list_all['map'+item.map_id].length >= 2 && (index == 0 || index == 1)?logo_index<12:logo_index<40)">
              <img :src="$store.state.img_req_url + logo.logo_path">
            </div>
          </div>
          <p @click="openClose(item.map_id, index)" class="open" v-if="list_all['map'+item.map_id].length >= 2 && (index == 0 || index == 1)?fa.arr.length > 12:fa.arr.length > 40">{{fa.is_open ? '收起':'展开'}} <i class="iconfont">{{fa.is_open ? '&#xe63b;':'&#xe648;'}}</i></p>
        </div>
      </div>
      <div class="share-area">
        <p>数据来源：{{item.src | empty('动脉橙产业智库')}}</p>
        <div class="right" @click="goShare(item.map_id)">
          <span>分享至</span>
          <div>
            <i class="iconfont">&#xe641;</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sortKeyAsc } from 'mobile/js/common'
export default {
  data() {
    return {
      list_all: {} // 'map'+id: [{name: '', module_id: '', is_open: false(未展开), arr: [item]}]
    }
  },
  props: ['list'],
  methods: {
    dealList() {
      for(let i of this.list) {
        if(this.$route.name === 'MSpecialDetail') {
          if (i.map_status == '0') {
            continue
          }
        }
        let temp_fa = i.content.filter((item) => { return item.pid == null })
        this.list_all['map'+i.map_id] = sortKeyAsc(this.subGroup(temp_fa), 'sort_num')
      }
    },
    subGroup(a) { // 分组
      let temp_content = []
      for(let j of a) {
        let obj = temp_content.find((item) => item.module_id == j.module_id)
        if (obj) {
          obj.arr.push(j)
        } else {
          temp_content.push({
            name: j.module_name,
            module_id: j.module_id,
            is_open: false,
            sort_num: j.sort_num,
            arr: [j]
          })
        }
      }
      return temp_content
    },
    openClose(map_id,index) { // 展开还是收起
      this.list_all['map'+map_id][index].is_open = !this.list_all['map'+map_id][index].is_open
      this.$forceUpdate()
    },
    goShare(id) {
      this.$router.push({name: 'MShareMap',params: {map_id: id},query: {theme_uid: this.$route.params.uid}})
    }
  },
  created() {
    this.dealList()
  }
}
</script>

<style lang="stylus" scoped>
.map-container
  margin-top: .3rem;
  .map-item
    .title
      color: #333333;
      font-size: .32rem;
      font-weight: bold;
      margin-bottom: .14rem;
      i
        font-weight: normal;
        color: #ff8824;
        font-size: .34rem;
    .summary
      font-size: .28rem;
      margin-bottom: .3rem;
      color: #333333;
      line-height: .44rem;
      // font-weight: bold;
    .logo-area
      padding: .1rem;
      border: 1px solid #FFB87C;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: .1rem;
      background-image: url('~pic/watermark-gray.png');
      .length1
        grid-column-start: span 4;
        border: 1px dashed #FFB87C;
        margin-top: .24rem;
        position: relative;
        .arr-title
          display: inline-flex;
          position: absolute;
          top: -.24rem;
          left: 50%;
          transform: translateX(-50%);
          width: 100%;
          justify-content: center;
          .left,.right
            width: .18rem;
            height: .48rem;
          .left
            margin-right: -1px
          .right
            margin-left: -1px
          .text
            background: #FFB87C;
            color: #FFFFFF;
            font-size: .24rem;
            padding: 0 .2rem;
            display: flex;
            align-items: center;
        .logos
          display: grid;
          grid-gap: .2rem;
          padding: .64rem .4rem .4rem;
          grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        .img-div
          width: 1rem;
          height: .4rem;
          display: flex;
          align-items: center;
          justify-content: center;
          img
            max-height: 100%;
            max-width: 100%;
        .open
          text-align: center;
          color: #FF8824;
          font-size: .28rem;
          margin-bottom: .24rem;
          i
            font-size: .2rem;
      .length2
        grid-column-start: span 2;
        .logos
          grid-template-columns: 1fr 1fr;
    .share-area
      margin-top: .34rem;
      display: flex;
      justify-content: space-between;
      p
        color: #999999;
        font-size: .24rem;
        line-height: .32rem;
      .right
        display: flex;
        margin-left: .4rem;
        min-width: 1.6rem;
        span
          font-size: .24rem;
          color: #999999;
          margin-top: 0.02rem;
        div
          width: .68rem;
          height: .68rem;
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          border: 1px #eee solid;
          margin-top: -.17rem;
          margin-left: .2rem;
          i
            color: rgb(46, 198, 107);
            font-size: .40rem;
  .map-item+.map-item
    margin-top: .3rem
</style>
